import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL, get } from "../api";
import { Order } from "../@types";

function useOrderDetails(
  orderId: string,
  options?: QueryObserverOptions<APIResponse<Order>, APIError>
) {
  const {
    data: order,
    isError,
    error,
    isLoading,
  } = useQuery<APIResponse<Order>, APIError>(
    "order-details-" + orderId,
    () =>
      get(API_URL + "/commerce/orders/" + orderId, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    order,
    isError,
    error,
    isLoading,
  };
}

export default useOrderDetails;
